<template>
    <div>
        <div class="form-row">
            <div class="form-row__col form-row__col--one-half">
                <form-input
                    name="input_client"
                    v-model="inputClient"
                >
                    {{ trans('global_search.label.input_client') }}
                </form-input>

            </div>
        </div>
        <div class="page-control">
            <div class="page-control__element page-control__element--margin-top"></div>
            <div class="page-control__element page-control__element--margin-top">
                <button @click.prevent="searchClient" class="btn btn--big btn--primary">{{ trans('buttons.search') }}</button>
            </div>
        </div>

        <div class="h:margin-bottom-6">
            <label class="form-section-heading">
                {{ trans('global_search.headline.search_results') }}
            </label>
        </div>

        <div class="form-row">
            <div class="form-row__col">
                <global-search-client-table></global-search-client-table>
            </div>
        </div>
    </div>
</template>

<script>
import { EventBus } from '../eventbus';
    export default {
        data() {
            return {
                inputClient: '',
                tableData: [],
            }
        },

        methods: {
            searchClient() {
                EventBus.$emit('globalSearchClient', this.inputClient);
            },
        },
    }
</script>
